import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/cashapp_merchant_deposit';

import {useEffect} from 'react';
import Triggers from '../../../../../lib/triggers';

import Bitcoin from './bitcoin';
import Create from './create';
import Confirm from './confirm';

export default () => {
    const {stage} = useSelector(Selector);

    useEffect(() => {
        Triggers.modal_open({
            modal: "wallet",
            tab: "deposit",
            method: "cashapp_pay"
        });
    }, [])

    if(stage === 'bitcoin') return <Bitcoin />
    if(stage === 'create') return <Create />
    if(stage === 'confirm') return <Confirm />
    return <>{stage}</>;
}